import SiteMap from "./SiteMap";
import { useNavigate } from "react-router-dom";

const SiteMapScreen = () => {

    //const [about, setAbout] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setAbout(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    return (
        <>
        <main className = 'item-main edit-profile about'>
            <section
                //className={styles.aboutsection}
                className = 'form property-information'
                //className = 'form'
                style = {{
                    paddingTop: "0px"
                    , paddingBottom: "80px"
                }}
                >
                <div className = { 'max-width' }>
                    <div
                        //className = 'flex-container'
                        className = { 'property-information' }
                        //style = {{ textAlign: "left" }}
                        >
                        
                        <SiteMap />
                        
                    </div>
                </div>
            </section>

        </main>
        </>
    );
};

export default SiteMapScreen;
